<div class="h-[100%] shadow-md rounded-2xl grid grid-cols-5 items-center">
  <span class="col-span-2 bg-[#eaf0f8] text-cliking_blue rounded-full h-12 w-12 ml-2 relative">
    <app-svg-palette [icon]="icon" />    
      <app-tool-tip class="absolute right-0 -mt-5"
        [toolTipClass]="'tooltip-left'"
        [Text]="tooltipText"
        [label]="''"
        />
  </span>
  <span class="col-span-3 font-semibold flex items-center justify-center">{{ value | kMNotation }}</span>
</div>
